import { render, staticRenderFns } from "./UserRegistrationDialog.vue?vue&type=template&id=4cee62d8&"
import script from "./UserRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistrationDialog.vue?vue&type=style&index=0&id=4cee62d8&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDialog,VDivider,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cee62d8')) {
      api.createRecord('4cee62d8', component.options)
    } else {
      api.reload('4cee62d8', component.options)
    }
    module.hot.accept("./UserRegistrationDialog.vue?vue&type=template&id=4cee62d8&", function () {
      api.rerender('4cee62d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/UserRegistrationDialog.vue"
export default component.exports